const formatDate = (date: Date | string): string => {
    const data = new Date(date);
    const dia = data.getDate();
    const mes = data.getMonth() + 1;
    const ano = data.getFullYear();
    const dataFormatada = `${dia < 10 ? '0' + dia : dia}/${mes < 10 ? '0' : ''}${mes}/${ano}`;
    return dataFormatada;
}

export default formatDate;
